import { __read } from "tslib";
import { useRef, useMemo, useEffect } from 'react';
import { geoMercator, geoAlbersUsa, geoOrthographic, geoGraticule, geoAzimuthalEqualArea, geoEqualEarth, geoNaturalEarth1, geoPath, } from 'd3-geo';
import { calculateRange } from '@keen.io/charts-utils';
import { calculateColorScale } from '../../../utils/colors.utils';
import { NOT_SUPPORT_ROTATION } from '../constants';
var projections = {
    mercator: geoMercator,
    geoAlbersUsa: geoAlbersUsa,
    orthographic: geoOrthographic,
    equalEarth: geoEqualEarth,
    naturalEarth: geoNaturalEarth1,
    azimuthalEqualArea: geoAzimuthalEqualArea,
};
export var generateChoropleth = function (_a) {
    var data = _a.data, projection = _a.projection, geoKey = _a.geoKey, valueKey = _a.valueKey, colorScale = _a.colorScale, dimension = _a.dimension, topology = _a.topology;
    var geoData = new Map();
    var width = dimension.width, height = dimension.height;
    var translation = projection.translation, rotation = projection.rotation, scale = projection.scale, type = projection.type;
    var mode = colorScale.mode, colors = colorScale.colors, steps = colorScale.steps;
    var geoProjectionRef = useRef(projections[type]());
    useEffect(function () {
        geoProjectionRef.current = projections[type]();
    }, [type]);
    var _b = __read(translation, 2), translateX = _b[0], translateY = _b[1];
    var _c = useMemo(function () { return calculateRange(data, 'auto', 'auto', [valueKey]); }, [valueKey, data]), minimum = _c.minimum, maximum = _c.maximum;
    var getColor = useMemo(function () { return calculateColorScale(minimum, maximum, mode, steps, colors); }, [minimum, maximum, mode, steps, colors]);
    data.forEach(function (item, idx) {
        var key = item[geoKey];
        geoData.set(key, {
            index: idx,
            data: item,
        });
    });
    geoProjectionRef.current
        .fitSize([width, height], topology)
        .translate([width / 2 + translateX, height / 2 + translateY])
        .scale(scale);
    if (!NOT_SUPPORT_ROTATION.includes(type)) {
        geoProjectionRef.current.rotate(rotation);
    }
    var graticule = useMemo(function () { return geoGraticule(); }, []);
    var drawPath = geoPath().projection(geoProjectionRef.current);
    return {
        graticule: graticule,
        drawPath: drawPath,
        getColor: getColor,
        geoProjection: geoProjectionRef.current,
        geoData: geoData,
    };
};
